import Person, { PersonProps } from 'src/components/fragments/Person';
import { Resident } from 'src/store/sageAdminApi';

export interface ResidentAvatarProps extends PersonProps {
    resident: Resident;
}

function ResidentAvatar(props: ResidentAvatarProps) {
    const { resident, ...personProps } = props;

    return <Person {...resident} {...personProps} isLoading={!resident} />;
}

export default ResidentAvatar;
